import React from 'react'
import { Link } from 'gatsby'
import { Layout, Header, Intro } from '../../../../components'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            The autosave component is now the{' '}
            <Link
              className="link"
              to={'/' + data.site + '/components/action-indicator/design'}
            >
              action indicator
            </Link>{' '}
            component. Visit that page for more information.
          </p>
        </Intro>
      </Layout>
    </>
  )
}
